// White-label configuration injected by Vite at build time via `define`
declare const __WL_CONFIG__: {
  API_ENDPOINT: string;
  SHAPE_ENDPOINT: string;
  WEB_ENDPOINT: string;
  KEYCLOAK_ENDPOINT: string;
  GOOGLE_MAPS_API_KEY: string;
  APP_TITLE: string;
  COMPANY_NAME: string;
  PRODUCT_NAME: string;
  NAVBAR_LINK: string;
  NAVBAR_COLOR: string;
  PHONE: string;
  MAIL: string;
  BUTTON: string;
  FIELDVIEW_API_OAUTH_URL: string;
  NATUP_OAUTH_AUTHORIZE_URL: string;
  NATUP_OAUTH_CLIENT_ID: string;
  ENV: string;
  APP_BASE: string;
};

const config = __WL_CONFIG__;

export const API_ENDPOINT = config.API_ENDPOINT + '/api';
export const SHAPE_ENDPOINT = config.SHAPE_ENDPOINT;
export const WEB_ENDPOINT = config.WEB_ENDPOINT;
export const KEYCLOAK_ENDPOINT = config.KEYCLOAK_ENDPOINT;
export const KEYCLOAK_JSON = 'keycloak-' + config.ENV + '.json';
export const GOOGLE_MAPS_API_KEY = config.GOOGLE_MAPS_API_KEY;
export const FIELDVIEW_API_OAUTH_URL: string = config.FIELDVIEW_API_OAUTH_URL;
export const NATUP_OAUTH_AUTHORIZE_URL: string = config.NATUP_OAUTH_AUTHORIZE_URL;
export const NATUP_OAUTH_CLIENT_ID: string = config.NATUP_OAUTH_CLIENT_ID;
export const APP_TITLE = config.APP_TITLE;
export const COMPANY_NAME = config.COMPANY_NAME;
export const PRODUCT_NAME = config.PRODUCT_NAME;
export const NAVBAR_LINK = config.NAVBAR_LINK;
export const PHONE = config.PHONE;
export const MAIL = config.MAIL;
export const ENV = config.ENV;
export const APP_BASE = config.APP_BASE;
